import { render } from "./ListaDeAgendamentosForm.vue?vue&type=template&id=4f92e932"
import script from "./ListaDeAgendamentosForm.vue?vue&type=script&lang=js"
export * from "./ListaDeAgendamentosForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__